import type { DatovkaApiType } from '@gov-nx/api';
import type { ExtraConfig } from '@gov-nx/core/app';

export const transformDataBoxes =
	(
		config: ExtraConfig['pageRoutes']['databoxConfig']['databoxTransformConfig']
	) =>
	(list: DatovkaApiType[]) => {
		if (config.deleteOdpojenoIfTrue) {
			return list.map((databox) => {
				const { odpojeno, ...rest } = databox;
				return odpojeno === true ? rest : databox;
			});
		}

		return list;
	};
